import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, message, Row, Col } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';
import axios from '../../config/axiosInstance';

const { Option } = Select;

const DeviceEditForm = ({ editingDevice, onClose }) => {
  const [clients, setClients] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await axios.get('/clients');
        setClients(response.data);
      } catch (error) {
        console.error('Error fetching clients:', error);
        message.error('Error fetching clients');
      }
    };

    fetchClients();

    if (editingDevice) {
      form.setFieldsValue({
        ...editingDevice,
        clientID: editingDevice.clientID?._id || editingDevice.clientID,
        realOwnerClientId: editingDevice.realOwnerClientId?._id || editingDevice.realOwnerClientId || null,
      });
    } else {
      form.resetFields();
    }
  }, [editingDevice, form]);

  const handleSave = async (values) => {
    try {
      const payload = {
        ...values,
        realOwnerClientId: values.realOwnerClientId || null,
      };

      await axios.put(`/devices/${editingDevice._id}`, payload);

      message.success('Device updated successfully');
      onClose();
    } catch (error) {
      console.error('Error updating device:', error);
      message.error('Error updating device');
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
      <Modal
          title="Edit Device"
          open={!!editingDevice}
          onCancel={handleCancel}
          onOk={() => form.submit()}
          okText="Save"
          cancelText="Cancel"
          width={800}
      >
        <Form
            form={form}
            onFinish={handleSave}
            layout="vertical"
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                  name="Name"
                  label="Name"
                  rules={[{ required: true, message: 'Please enter the device name' }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                  name="clientID"
                  label={
                    <span>
                  <UsergroupAddOutlined style={{ fontSize: '18px', color: '#1890ff', marginRight: '5px' }} />
                  Client
                </span>
                  }
                  rules={[{ required: true, message: 'Please select a client!' }]}
              >
                <Select
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select a client"
                >
                  {clients.map((client) => (
                      <Option key={client._id} value={client._id}>
                        {client.name}
                      </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                  name="realOwnerClientId"
                  label={
                    <span>
                  <UsergroupAddOutlined style={{ fontSize: '18px', color: '#52c41a', marginRight: '5px' }} />
                  Real Owner
                </span>
                  }
              >
                <Select
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    placeholder="Select real owner client"
                >
                  {clients.map((client) => (
                      <Option key={client._id} value={client._id}>
                        {client.name}
                      </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                  name="SerialNumber"
                  label="Serial Number"
              >
                <Input readOnly style={{ cursor: 'default', color: 'inherit' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                  name="Platform"
                  label="Platform"
                  rules={[{ required: true, message: 'Please select a platform' }]}
              >
                <Select>
                  <Option value="iOS">iOS</Option>
                  <Option value="Windows">Windows</Option>
                  <Option value="Android">Android</Option>
                  <Option value="MacOS">MacOS</Option>
                  <Option value="iPadOS">iPadOS</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="VersionString" label="Version">
                <Input readOnly style={{ cursor: 'default', color: 'inherit' }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="Manufacturer" label="Manufacturer">
                <Input readOnly style={{ cursor: 'default', color: 'inherit' }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                  name="Idiom"
                  label="Idiom"
                  rules={[{ required: true, message: 'Please select an idiom' }]}
              >
                <Select placeholder="Select a device idiom">
                  <Option value="Phone">Phone</Option>
                  <Option value="Tablet">Tablet</Option>
                  <Option value="Desktop">Desktop</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="Model" label="Model">
                <Input readOnly style={{ cursor: 'default', color: 'inherit' }} />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item name="Type" label="Type">
                <Input readOnly style={{ cursor: 'default', color: 'inherit' }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
  );
};

export default DeviceEditForm;